export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5551.cdb81775.jpg";